import { render, staticRenderFns } from "./DeleteSenderModal.vue?vue&type=template&id=65416d92&scoped=true"
import script from "./DeleteSenderModal.vue?vue&type=script&lang=js"
export * from "./DeleteSenderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65416d92",
  null
  
)

export default component.exports